import styled, { keyframes } from 'styled-components';

const circleAnimation = keyframes`
	0% {
		width: 100px;
		height: 100px;
		border-radius: 100px;
		border: 1px solid rgba(255, 255, 255, 0.2);
	}
	100% {
		width: 300px;
		height: 300px;
		border-radius: 300px;
		border: 1px solid rgba(255, 255, 255, 0);
	}
`;

const StyledContainer = styled.div`
	position: absolute;
	top: 13px;
	left: 50%;
	z-index: -2;
	transform: translateX(-50%);
	display: flex;
	align-items: center;
	justify-content: center;
	height: 300px;
`;

const StyledCircle = styled.div`
	position: absolute;
	width: 100px;
	height: 100px;
	border-radius: 100px;
	border: 1px solid rgba(255, 255, 255, 0);
	animation-name: ${circleAnimation};
	animation-duration: 2s;
	animation-timing-function: ease;
	animation-iteration-count: infinite;
`;

const StyledFirstCircle = styled(StyledCircle)`
	animation-delay: 0.66s;
`;

const StyledSecondCircle = styled(StyledCircle)`
	animation-delay: 1.33s;
`;

const StyledThirdCircle = styled(StyledCircle)`
	animation-delay: 2s;
`;

export {
	StyledContainer,
	StyledFirstCircle,
	StyledSecondCircle,
	StyledThirdCircle,
};
